<form class="h-100" [formGroup]="from" autocomplete="off">
  <div class="d-flex flex-column h-100">
    <div class="gx-3 row">
      <div class="col-sm-6 mb-3">
        <input-field
          [label]="'Reference'"
          [type]="'text'"
          [placeholder]="'Enter Reference'"
          formControlName="reference"
          [requiredLabel]="true"
          [errormessage]="'Reference is required'"
        >
        </input-field>
      </div>
    </div>
  </div>
</form>
